import { useQuery } from '@tanstack/react-query'
import {
  EducatorCohortDetailsService,
  type EducatorCohortDetailsResponse,
} from '@mc/api'

export const useCohortDetails = ({
  initialData,
}: {
  /** SSR-seeded cache so prefetching surfaces (Overview) render in the initial HTML. */
  initialData?: EducatorCohortDetailsResponse
} = {}) =>
  useQuery<EducatorCohortDetailsResponse>({
    queryKey: ['educator-cohort-details'],
    queryFn: () => EducatorCohortDetailsService.getEducatorCohortDetails(),
    staleTime: 5 * 60 * 1000,
    retry: false,
    initialData,
  })
